//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: 'SkillList',
    props: ['title', 'items'],

    data(){ return {
        debug: false,
        load: false,
    }},

    methods: {
        intersect(a){
            if(this.load) return;

            if(a.isIntersecting){
                this.load = true

                if(this.debug)
                console.log('Loading Skills', this.title)
            }
        }
    }
}
